import { secToPx } from '../../../lib/timelineMath'

/**
 * Bug (found while investigating 小林's timeline/timebar report, 2026-09-05):
 * `store.playback.currentSec` is only ever re-clamped by `setPlayhead` (and,
 * for the project-switch/自動編集-rerun cases, reset outright) — but ANY
 * Composition edit that shrinks the total duration WITHOUT going through
 * `setPlayhead` (trimming/deleting/reordering a Segment, shortening an
 * Overlay/AudioClip — `updateSegment`/`removeSegment`/`updateOverlay`/etc.,
 * none of which touch `playback`) leaves a stale `currentSec` pointing past
 * the new, shorter timeline (DOM-verified for the 自動編集-rerun case before
 * that one got its own explicit reset in the store). Rather than chase every
 * such mutation call site individually, this component (and PlaybackBar's
 * `current-time` text) clamp for DISPLAY against the CURRENT `totalSec` —
 * always freshly re-derived from the live Composition on every render — so
 * the marker/readout can never visually overrun the timeline regardless of
 * which edit shrank it.
 */
export function Playhead({
  currentSec,
  totalSec,
  pxPerSec,
}: {
  currentSec: number
  totalSec: number
  pxPerSec: number
}) {
  const clamped = Math.min(Math.max(0, currentSec), totalSec)
  return (
    <div
      className="absolute top-0 bottom-0 w-px bg-accent-red pointer-events-none z-20"
      style={{ left: secToPx(clamped, pxPerSec) }}
      data-testid="playhead"
    >
      <div className="absolute -top-0.5 -left-[3px] w-[7px] h-[7px] rotate-45 bg-accent-red" />
    </div>
  )
}

/** 吸着中のガイド線（task spec §2-8: 黄色 #E6B422）。sec が null の間は何も描かない。 */
export function SnapGuide({ sec, pxPerSec }: { sec: number | null; pxPerSec: number }) {
  if (sec == null) return null
  return (
    <div
      className="absolute top-0 bottom-0 w-px bg-accent-gold pointer-events-none z-30"
      style={{ left: secToPx(sec, pxPerSec) }}
      data-testid="snap-guide"
    />
  )
}
